import { ILanguage } from "../types";

export const ja: ILanguage = {
  translation: {
    root: {
      customize: "カスタマイズ",
      businessAccount: "ビジネスアカウント",
      verificationStatus: "検証ステータス",
      note: "注記",
      companyInformation: "会社の情報",
      businessName: "商名*",
      enterBusinessName: "ビジネス名を入力します",
      registrationNumber: "会社Reg。",
      registrationNumberPlaceholder: "登録番号を入力します",
      taxVat: "税/VAT登録番号",
      vatPlaceholder: "税/VAT登録番号を入力します",
      registeredAddress: "登録アドレス*",
      tradingAddress: "取引住所*",
      sameAsRegisteredAddress: "登録アドレスと同じ",
      billingInformation: "請求情報",
      billingPhoneNo: "請求電話番号*",
      phonePlaceholder: "電話番号を入力 ",
      billingEmail: "請求メール*",
      mode: "モード",
      comments: "コメント",
      emailPlaceholder: "請求メールを入力してください",
      driverDetails: "ドライバーの詳細",
      customerVerificationStatus: "顧客検証ステータス：",
      enterNationalInsuranceNumber: "国民保険番号を入力してください",
      enterYourProfession: "あなたの職業を入力してください",
      enterDriving: "運転に入ります",
      profileImage: "プロファイル画像",
      number: "番号",
      image: "画像",
      uploadBack: "アップロードします",
      uploadFront: "前面をアップロードします",
      issuedBy: "発行者",
      document: "書類",
      selectDocument: "ドキュメントを選択します",
      addFile: "ファイルを追加します",
      noDataFound: "データは見つかりません",
      noDocumentsFound: "文書は見つかりません",
      documentUpdatedAt: "で更新されたドキュメント",
      selectExpiryDate: "有効期限を選択します",
      selectExpiryDateUpload:
        "アップロードする前に有効期限を選択してください。",
      editExpiryDate: "有効期限を編集します",
      middleName: "ミドルネーム",
      middleNameLabel: "ミドルネーム",
      enterMiddleName: "ミドルネームを入力",

      status: "状態",
      images: "画像",
      profession: "職業",
      nationality: "国籍",
      driving: "運転",
      listOfDocumentsUploaded: "アップロードされたドキュメントのリスト",
      listOfRequiredDocumentsUploaded:
        "アップロードされた必要なドキュメントのリスト",
      documentType: "ドキュメントタイプ",
      documentName: "ドキュメント名",
      expiryDate: "有効期限",
      confirmDelete: "削除を確認します",
      actions: "アクション",
      completed: "完了しました",
      pending: "保留中",
      documentDeleteConfirmMsg: "このドキュメントを削除したいですか？",
      address: "住所",
      useRegisteredAddress: "登録アドレスを使用します",
      billingEmailAddress: "請求メールアドレス*",
      billingEmailLabel: "請求メールアドレス",
      accountNumber: "口座番号",
      firstName: "ファーストネーム*",
      firstNameLabel: "ファーストネーム",
      lastName: "苗字*",
      lastNameLabel: "苗字",
      contactEmail: "メールアドレスにお問い合わせください*",
      emailLabel: "電子メールアドレス",
      contactPhone: "電話番号にお問い合わせください*",
      registeredAddressCaps: "登録アドレス",
      tradingAddressCaps: "取引アドレス",
      billingInformationCaps: "請求情報",
      customerContactCaps: "顧客の連絡先",
      contactEmailInvalid: "有効な連絡先メールを入力してください。",
      typeAddress: "入力アドレス",
      taxFees: "税金と手数料",
      vatTax: "VAT/税",
      registrationNum: "登録番号",
      drivingLicenceNumber: "運転免許証番号",
      invalidPhoneNumber: "無効な電話番号",
      onStartEmail: "開始方法についてメールを送りました。",
      emailNotSeen:
        "数分でメールが表示されない場合は、「ジャンクメール」または「スパムフォルダー」を確認してください。",
      registerNow: "今すぐ登録",
      email: "メール",
      thankYou: "ありがとう",
      pickUpLocation: "受取場所 ",
      returnLocation: "返却場所 *",
      pickUpDate: "受取日 *",
      pickUpTime: "受取時間 *",
      invalidPickupLeadTime: "選択した受取日時は許可された予約期間外です",
      dropOffDate: "返却日 *",
      searchVehicles: "車両を検索",
      chooseLocation: "場所または郵便番号を入力してください",
      vehicleGallery: "車両ギャラリー",
      privacyPolicy: "プライバシーポリシー",
      termsAndConditions: "利用規約",
      dropOffTime: "返却時間 *",
      noVehiclesFound: "選択した条件に一致する車両が見つかりませんでした",
      noRecordFound: "申し訳ありませんが、一致する記録が見つかりませんでした！",
      vehicles: "車両",
      endDate: "終了日",
      startDate: "開始日",
      past: "過去",
      search: "検索",
      upcoming: "今後の予定",
      current: "現在",
      all: "すべて",
      more: "もっと見る",
      toBeAssigned: "未割り当て",
      ref: "参照番号",
      reservation: "予約",
      booking: "予約",
      pricingSummary: "料金の概要",
      bookingSummary: "予約概要",
      subscriptionVehicle: "サブスクリプション車両",
      insurance: "保険",
      addons: "追加オプション",
      protectionPlan: "保護プラン",
      initialRental: "初回レンタル料金",
      enrollmentFee: "登録料",
      quantity: "数量",
      subscriptionPrice: "サブスクリプション料金",
      weekly: "毎週",
      monthly: "毎月",
      on: "に",
      numberOfDoors: "ドアの数",
      numberOfSeats: "座席数",
      transmission: "トランスミッション",
      fuelType: "燃料タイプ",
      week: "週",
      day: "日",
      hour: "時間",
      month: "月",
      gropu1Icon: "グループ1アイコン",
      vatInclusive: "税込",
      vat: "消費税",
      rental: "レンタル",
      speedometer: "スピードメーター",
      available: "利用可能",
      priceLowToHigh: "価格が安い順",
      priceHighToLow: "価格が高い順",
      weHaveSmartCars: "スマートカーをご用意しています",
      keylessSupport: "当社のスマートカーはキーレスに対応しています",
      keylessVehicles: "キーレス車両を表示",
      duration: "期間",
      swapsAllowed: "交換可能",
      enrollmentAmount: "登録金額",
      subscriptionAmount: "サブスクリプション金額",
      mileageLimit: "走行距離制限",
      unlimited: "無制限",
      weeks: "週",
      months: "月",
      pricePerExtraMile: "追加マイルあたりの料金",
      insurancePolicy: "保険ポリシー",
      removeSubscription: "サブスクリプションを削除",
      noGroupFound: "この条件に一致するグループが見つかりません！",
      vehicleTypeIcon: "車両タイプアイコン",
      min: "最小",
      selected: "選択済み",
      vehiclesSelected: "選択された車両",
      selectVehicles: "車両を選択",
      personalDetails: "個人情報",
      selectAddons: "アドオンを選択",
      continue: "続行",
      locationSurcharge: "ロケーション追加料金",
      onTotalRentalAmount: "レンタル料金合計に対して",
      oneWayFee: "片道料金",
      oneWayRentalCharge: "片道レンタル料金",
      total: "合計",
      firstMonthTotal: "初月合計",
      firstWeekTotal: "初週合計",
      depositPayable: "引取時支払いのデポジット",
      deposit: "デポジット",
      insuranceCaps: "保険",
      customAddon: "カスタムアドオン",
      chooseAPolicy: "ポリシーを選択",
      rate: "料金",
      typeOfValet: "バレットの種類",
      nonNegotiable: "交渉不可",
      selectValet: "バレットを選択",
      collectionAddress: "引取住所",
      remove: "削除",
      deliveryAddress: "配送先住所",
      additionalInformation: "追加情報",
      confirmBooking: "予約を確定",
      proceed: "進む",
      getQuote: "見積もりを取得",
      for: "対象",
      agreeWithTermsAndConditions: "利用規約に同意します",
      selectCostCenter: "コストセンターを選択",
      action: "操作",
      name: "名前",
      enterDrivingLicenceNumber: "運転免許証番号を入力",
      enterLastName: "姓を入力",
      enterFirstName: "名を入力",
      enterYourMail: "メールアドレスを入力",
      emailAsterisk: "メールアドレス*",
      quoteGeneratedCaps: "見積もりが生成されました",
      updated: "更新済み",
      rentalCharges: "レンタル料金",
      totalPayableAmount: "支払総額",
      payMinimumAmount: "最低額を支払う",
      dueAmountPaidWhilePickup: "引取時に支払う金額",
      payOnCollection: "引取時に支払う",
      CardAuthorization:
        "カードは今認証され、金額は以下の時に引き落とされます：",
      starts: "開始",
      confirm: "確認",
      payAtTimeOfPickup: "今は支払わず、引取時に支払う",
      payFullAmountNow: "今すぐ全額支払う",
      payFullAmountRightAway: "即座に全額支払う",
      FutureChargesRelatedToOngoingBooking:
        "進行中の予約に関連する今後の料金はこの支払方法で請求されます",
      saveThisCardForFutureInvoices:
        "このカードを将来の請求用に保存する {{bookingSyntax}}",
      payLater: "後で支払う",
      creditLimitAssigned:
        "このビジネスに割り当てられたクレジットリミットがこの支払いに使用されます",
      CreditsAgainstBooking: "予約に対してクレジットが使用されます",
      useCreditNoteBalance: "クレジットノート残高を使用",
      telNo: "電話番号",
      vatNo: "VAT番号",
      customer: "顧客",
      emailAddress: "メールアドレス",
      phoneNumber: "電話番号",
      dateCreated: "作成日",
      poNumber: "注文番号",
      dateTime: "日時",
      dropOffLocation: "返却場所",
      contractHire: "契約レンタル",
      subscription: "サブスクリプション",
      charges: "料金",
      enrollmentFees: "登録料金",
      na: "該当なし",
      grandTotal: "総合計",
      rentalPrice: "レンタル料金",
      daysProRated: "日数に応じた計算",
      locationSurcharges: "ロケーション追加料金",
      ofTotalRentalAmount: "レンタル料金総額の",
      nextBilling: "次回請求日",
      subTotal: "小計",
      discount: "割引",
      discountedPrice: "割引価格",
      description: "説明",
      descriptionLabel: "説明",
      thisIsA: "これは",
      exemptedBooking: "免除された予約です",
      thisIstestCourtsey: "これはテスト/ご厚意の予約です",
      isCalculatedAgainst: "に対して計算されます",
      priceAndSelectedAddons:
        "価格と選択されたアドオン、保険とデポジットを除く",
      recurringWeeklyMonthlyInvoice:
        "定期的な週次／月次請求書は次週／翌月分として自動生成されます。",
      additionalNote: "追加の注意事項",
      payableAtVehicleCollection: "車両引取時に支払う金額",
      purchaseOrderUpdated: "注文番号が正常に更新されました",
      proceedToPay: "支払いに進む",
      searchResults: "検索結果",
      subscriptions: "サブスクリプション",
      contractHireVehicleWeeklyMonthly: "週/月単位の契約車両",
      subscribeVehicleWeeklyMonthly: "週/月単位の車両をサブスクライブ",
      contractNow: "今すぐ契約",
      subscribeNow: "今すぐサブスクライブ",
      backToBookingCategorySelection: "予約カテゴリの選択に戻る。",
      accountVerification: "アカウント確認",
      profileNotVerifiedMessage:
        "プロフィールが確認されていません。オペレーターに連絡してアカウント確認プロセスを完了し、続行してください。",
      update: "更新",
      reference: "参照",
      companyRegistrationNumber: "法人登録番号",
      availableFrom: "利用可能日",
      paellaDish: "パエリア料理",
      vehicleCatalogues: "車両カタログ",
      vehicleDetails: "車両の詳細",
      verification: "確認",
      protectionPlans: "補償プラン",
      authorisedSignatory: "署名権限者",
      item: "商品",
      price: "価格",
      unitPrice: "単価",
      vehicleSpecification: "車両仕様",
      model: "モデル",
      color: "色",
      bodyType: "ボディタイプ",
      tankCapacity: "タンク容量",
      interiorColor: "内装色",
      seats: "座席数",
      doors: "ドア数",
      whatsIncluded: "含まれる内容",
      timeVehicleSwap: "車両交換時間",
      contractualDetails: "契約の詳細",
      longerSubscribeSaveMore: "長く契約するほどお得になります",
      tailorSubscriptionToNeeds: "ニーズに合わせて契約を調整",
      easyManagementOnline: "オンラインで簡単管理",
      SwapCarAndCancel: "車を交換、またはいつでもキャンセル可能",
      customizeYourContract: "契約内容をカスタマイズ",
      selectPlan: "プランを選択",
      selectTenure: "期間を選択",
      tentativeStartDate: "仮の開始日",
      selectDate: "日付を選択",
      selectTime: "時間を選択",
      contractSummary: "契約の概要",
      subscriptionChargesLabel: "サブスクリプション料金",
      initialRentalPayment: "初回レンタル支払い",
      continueToPersonalDetails: "個人情報の入力へ進む",
      noAvailableAddonsFound:
        "検索条件に一致する利用可能なアドオンが見つかりませんでした",
      nationalInsuranceNumber: "国民保険番号",
      updateQuote: "見積もりを更新",
      driverNotAvailable:
        "ドライバーが利用できません。レンタル運営者にご連絡ください",
      selectDeliverySlot: "配達時間帯を選択",
      wantDelivered: "配達を希望しますか？",
      verifyYourLicenceCaps: "免許証を確認",
      validateAllFieldsForLicenceCheck:
        "以下の情報を入力または確認してください。すべての項目は必須です。",
      postCode: "郵便番号",
      thisAgreementAllows: "この契約により",
      leftoverAgreement:
        "および当社の保険パートナーがあなたの運転免許証の確認を行い、提供された情報を保険会社および関連する第三者（Coastr）に提供して車両のレンタル・保険の管理に使用することを許可します。同意しますか？",
      verifyLicence: "免許証を確認",
      licenceCheckingInProgress: "免許証の確認中",
      checkingInProgress:
        "最大2分かかる場合があります。ブラウザを閉じないでお待ちください。",
      licenceCheckingFailed: "免許証の確認に失敗しました",
      checkForCorrectDetails: "正しい情報が入力されているか確認してください。",
      tryAgainLater: "問題が解決しない場合は、後でもう一度お試しください。",
      licenceCheckedSuccessfully: "免許証の確認が完了しました",
      licenceSummaryAdded: "免許の要約が顧客レコードに追加されました",
      creditScore: "クレジットスコア",
      lastChecked: "最終確認日",
      recheckCreditScore: "クレジットスコアを再確認",
      checkCreditScore: "クレジットスコアを確認",
      proceedToPayment: "支払いに進む",

      paymentOverview: "支払い概要",
      schedule: "スケジュール",
      contractDetails: "契約詳細",
      plan: "プラン",
      swaps: "交換",
      payableDeposit: "支払うべきデポジット",
      customerVerification: "顧客確認",
      provideAdditionalDetails:
        "予約を作成するには、アカウントセクション内で次の追加情報を提供してください",
      profilePhoto: "プロフィール写真",
      submitYourRequest:
        "完了したら、下の送信ボタンをクリックして承認を申請してください",
      submit: "送信",
      uploadLicenceImages: "運転免許証の画像をアップロード",
      add: "追加",
      uploadFrontBackLicence:
        "免許証の表面と裏面の画像をアップロードしてください。対応形式: .png, .jpeg, .jpg!",
      uploadLicenceImage: "免許証画像をアップロード",
      authority: "発行機関",
      drivingLicenceExpiryDate: "運転免許証の有効期限",
      licenceNumber: "免許証番号",
      preview: "プレビュー",
      addOn: "アドオン",
      contact: "連絡先",
      selectSlot: "スロットを選択",
      deliveryType: "配達タイプ",
      experience: "体験",
      type: "タイプ",
      bookATestDrive: "試乗を予約する",
      selectASlot: "スロットを選択してください",
      selectDateTimeSlot: "日時を選択",
      vehicleNotAvailable: "選択した日付の車両は利用できません",
      selectDifferentDate: "別の日付を選択してください",
      selectCar: "車を選択",
      availableNow: "今すぐ利用可能",
      new: "新着",
      phone: "電話",
      customerDetails: "顧客情報",
      dealershipAddress: "ディーラーの住所",
      dealership: "ディーラー",
      bookingTime: "予約時間",
      bookingType: "予約タイプ",
      details: "詳細",
      your: "あなたの",
      confirmation: "確認",
      selectDealership: "ディーラーを選択",
      testDriveRequested: "試乗がリクエストされました",
      testDrive: "試乗",
      mobileNumber: "携帯番号",
      drivingLicenseNumber: "運転免許番号",
      enterLicenseNumber: "免許番号を入力",
      requestTestDrive: "試乗をリクエスト",
      slot: "スロット",
      vehicle: "車両",
      selectSubsctiption: "サブスクリプションを選択",
      pricesShownOnSelectedDuration: "表示価格は選択した期間に基づいています",
      priceComparison: "価格比較",
      oneTime: "一回限り",
      subscriptionStartsAt: "サブスクリプション開始価格",
      paymentProcessing: "支払い処理中",
      pleaseWait: "お待ちください",
      paymentComplete: "支払い完了",
      paymentInProgress: "支払い処理中",
      atleastUploadOne: "最低1つアップロードしてください",
      upload: "アップロード",
      uploadServiceNotAvailable: "アップロードサービスが利用できません。もう一度お試しください。",
      uploading: "アップロード中...",
      atDealership: "ディーラーで",
      atHome: "自宅で",

      enterYourEmailPassword:
        "ログインするにはメールアドレスとパスワードを入力してください",
      enterMailHere: "ここにメールアドレスを入力してください",
      required: "必須",
      password: "パスワード",
      reset: "リセット",
      otpForPasswordReset: "パスワードリセット用のOTPがメールで届きます",
      sendOtp: "OTP送信",
      loginInstead: "代わりにログイン",
      verifyOtp: "OTPを確認",
      otp: "OTP",
      otpSentToEmail: "OTPがメールに送信されました",
      enterOtp: "OTPを入力してください",
      enterOtpHere: "ここにOTPを入力してください",
      verify: "確認",
      setNewPassword: "新しいパスワードを設定",
      eightCharLong: "8文字である必要があります",
      reenterPassword: "ここにパスワードを再入力してください",
      signInAs: "としてサインイン",
      as: "として",
      selectAccountToProceed: "続行するアカウントを選択してください",
      personalAccount: "個人アカウント",
      asBusinessCustomer: "ビジネス顧客として",
      asDriver: "ドライバーとして",
      enterPassword: "ここにパスワードを入力してください",
      registerAs: "登録する",
      individual: "個人",
      business: "ビジネス",
      operatorMandatedCustomerCheck:
        "オペレーターにより確認済みの予約のために顧客確認が要求されています。承認をお待ちください。",
      createAccount: "アカウント作成",
      emailedHowToGetStarted: "開始方法についてメールを送信しました。",
      ifDontSeeEmail:
        "数分以内にメールが届かない場合は、迷惑メールフォルダをご確認ください。",
      previousVehicleDetails: "以前の車両情報",
      registration: "登録",
      makeModel: "ブランド/モデル",
      vin: "VIN番号",
      driverAssigned: "ドライバーが割り当てられました",
      currentVehicleDetails: "現在の車両情報",
      priceGroup: "価格グループ",
      unlimitedMileage: "無制限走行距離",
      paymentStatus: "支払状況",
      invoiceNumber: "請求書番号",
      deliveryDetails: "配送詳細",
      collectionDetails: "受取詳細",
      coiDetails: "COI情報",
      policyName: "保険名",
      planName: "プラン名",
      policyNumber: "ポリシー番号",
      provider: "提供者",
      vehicleSwapDetails: "車両交換情報",
      swapMyCar: "車を交換",
      NoOfSwapsAllowed: "交換可能回数",
      NoOfSwapsAvailed: "使用済み交換回数",
      NoOfSwapsRemaining: "残り交換回数",
      swapRequestHistory: "交換リクエスト履歴",
      requestedOn: "リクエスト日時",
      swapDate: "交換日",
      oldVehicle: "旧車両",
      newVehicle: "新車両",
      addonsDetails: "アドオン情報",
      paymentDetails: "支払い詳細",
      billingPeriod: "請求期間",
      creationDate: "作成日",
      invoiceType: "請求書タイプ",
      regular: "通常",
      depositDetails: "デポジット情報",
      amount: "金額",
      totalPaidAmount: "支払総額",
      cancellationCharges: "キャンセル料",
      totalRefundAmount: "払い戻し総額",
      anUnpaid: "未払い",
      aPartiallyPaid: "一部支払い済み",
      thisIs: "これは",
      pleaseContactUs: "お問い合わせはご連絡ください",
      reasonToCancelTheBooking: "予約取り消しの理由を選択してください",
      enterTheReason: "理由を入力してください",
      dismiss: "却下",
      selectVehicle: "車両を選択",
      bookingConfirmationInProgress: "予約確認中",
      pleaseProvideTheReason: "理由を入力してください",
      quote: "見積もり",
      management: "管理",
      pickupDateTimePassed:
        "ピックアップ日時が過ぎているか、料金が発生しません",
      profileRejectedOrPending: "プロフィールは拒否されるか、承認待ちです",
      testDriveAgreement: "試乗契約",
      rentalAgreement: "レンタル契約",
      contractHireAgreement: "コントラクトハイヤー契約",
      subscriptionAgreement: "サブスクリプション契約",
      zeroChargeBooking: "無料予約はオペレーターのみが確認できます",
      pickupDateTimeInPast: "ピックアップ日時が過去です",
      creditNoteSummary: "クレジットノート概要",
      customerName: "顧客名",
      customerEmail: "顧客のメール",
      creditNoteRef: "クレジットノート参照",
      invoiceRef: "請求書参照",
      totalAmount: "合計金額",
      amountAdjustedRefunded: "調整/返金金額",
      amountAvailable: "利用可能金額",
      adjustments: "調整",
      particulars: "詳細",
      adjustedToInvoice: "請求書に調整済み",
      adjustedAt: "調整日時",
      creditNotes: "クレジットノート",
      availableBalance: "利用可能残高",
      searchCreditNoteId: "クレジットノートIDを検索",
      active: "アクティブ",
      exhausted: "使い切り",
      creditNoteId: "クレジットノートID",
      dateGenerated: "生成日",
      amountRefunded: "返金額",
      amountRemaining: "残高",
      dashboard: "ダッシュボード",
      activeVehiclesCount: "稼働中車両数",
      totalActiveBookings: "合計稼働中予約数",
      totalVehicles: "総車両数",
      vehicleChecks: "車両点検",
      inProgressBookings: "進行中の予約",
      vehicleChecksCompleted: "車両点検完了",
      vehicleChecksPending: "車両点検未実施",
      dailyBalance: "日次残高",
      totalOutstanding: "未払い合計",
      UnpaidInvoices: "未払い請求書数",
      regularInvoices: "通常請求書",
      sundryInvoices: "その他の請求書",
      addNewDriver: "ドライバーを追加",
      phoneNo: "電話番号",
      drivingLicenceImage: "運転免許証画像",
      licenceIssuedBy: "免許発行者",
      licenceExpiryDate: "免許有効期限",
      drivingLicenceIssueDate: "運転免許証の発行日",
      dateOfBirth: "生年月日",
      taskDetailsNotFound: "タスク詳細が見つかりません。",
      bookingRef: "予約参照",
      rateYourExperience: "体験を評価",
      driverInformation: "ドライバー情報",
      saveDrivers: "ドライバーを保存",
      expiry: "有効期限",
      areYouSureDriver: "本当にこのドライバーを削除しますか？",
      drivers: "ドライバー",
      noDriverFound: "申し訳ありません、ドライバーが見つかりません！",
      invoices: "請求書",
      searchInvoiceId: "請求書IDを検索",
      pcoIssueDate: "運転手のPCOライセンス発行日",
      unpaid: "未払い",
      paid: "支払い済み",
      void: "無効",
      invoiceId: "請求書ID",
      invoiceDate: "請求書日付",
      balanceDue: "未払い残高",
      dueDate: "支払期限",
      invoiceSummary: "請求書概要",
      invoice: "請求書",
      sundry: "雑多",
      addPayment: "支払いを追加",
      customerPhoneNumber: "顧客電話番号",
      invoiceReference: "請求書参照",
      period: "期間",
      invoiceVoidedBy: "請求書を無効にした人",
      invoicePeriod: "請求書期間",
      invoiceStatus: "請求書ステータス",
      invoiceAmount: "請求書金額",
      amountDue: "支払額",
      generatedAt: "生成日時",
      vehicleRentalCharges: "車両レンタル料金",
      refundable: "返金可能",
      date: "日付",
      thisIsTestCourtsey: "これはテスト/礼儀です",
      invoicesConsolidated: "請求書統合済み",
      payments: "支払い",
      exempted: "免除済み",
      pleaseLoginFirst: "まずログインしてください",
      account: "アカウント",
      tracking: "追跡",
      uploadImages: "画像をアップロード",
      updateVehicleState: "車両状態を更新",
      vehicleImage: "車両画像",
      fuelStatus: "燃料ステータス",
      batteryStatus: "バッテリーステータス",
      odometerReading: "オドメータ読み取り",
      nextServiceDetails: "次回サービス詳細",
      serviceType: "サービス種別",
      serviceStatus: "サービス状況",
      appointmentDate: "予約日",
      estdCompletionDate: "予定完了日",
      serviceProviderName: "サービス提供者名",
      serviceProviderAddress: "サービス提供者住所",
      notesForDriver: "運転手へのメモ",
      exteriorDamages: "外装ダメージ",
      interiorDamages: "内装ダメージ",
      generalChecks: "一般点検",
      accessoriesChecks: "アクセサリ点検",
      chooseFuelLevel: "燃料レベルを選択",
      lastReported: "最終報告",
      circumstance: "状況",
      title: "タイトル",
      damageKind: "ダメージの種類",
      damageArea: "ダメージ箇所",
      referenceNumber: "参照番号",
      damageDetail: "ダメージ詳細",
      addImage: "画像を追加",
      addImages: "画像を追加",
      done: "完了",
      searchExistingDriver: "既存のドライバーを検索",
      success: "成功",
      assignDriver: "ドライバーを割り当て",
      plate: "ナンバープレート",
      unassigned: "未割当",
      assigned: "割当済み",
      make: "メーカー",
      vehicleAppearOnceAssigned: "割り当てられると車両が表示されます！",
      searchVehicle: "車両を検索",
      trackingHistoryHrs: "追跡履歴（時間）",
      telemetryDevice: "テレメトリー機器",
      lastLocation: "最終位置",
      latitude: "緯度",
      longitude: "経度",
      forSelectedPeriod: "選択した期間 –",
      milesDriven: "走行マイル数",
      engineHours: "エンジン稼働時間",
      fuelUsageLitres: "燃料使用量（リットル）",
      stoppagehours: "停止時間",
      chargeStatus: "充電状況",
      fuelUsage: "燃料使用量",
      batteryLevel: "バッテリーレベル",
      speedLimit: "制限速度",
      invalidEmailAddress: "無効なメールアドレス",
      unableLoadCompanyDetails: "会社情報を読み込めません",
      bookingConfirmationProgress: "予約確認中…",
      doNotHitBack:
        "「戻る」「キャンセル」「ブラウザを閉じる」を押さないでください。この処理には最大2分かかることがあります。",
      summary: "概要",

      addNew: "新規追加",
      street: "通り",
      city: "市区町村",
      regionState: "地域／都道府県",
      country: "国",
      zipPostalCode: "郵便番号",
      cardAuthorizeNowButAmountLater:
        "カードは今承認されますが、料金は予約開始時に請求されます",
      saveThisCardForFutureInvoicesBooking:
        "このカードを保存して、今後の請求書の支払いに使用します。",
      confirmBookingPayLater: "予約を確定して後で支払う",
      confirmBookingAndPayAtPickup: "今すぐ予約を確定し、受け取り時に支払う",
      bookingReferenceNumber: "予約参照番号",
      pickupDetails: "受け取りの詳細",
      dropoffDetails: "返却の詳細",
      to: "〜まで",
      bookingReference: "予約参照",
      invoiceStartDate: "請求開始日：",
      invoiceEndDate: "請求終了日：",
      availableAtLocations: "利用可能な場所",
      benefits: "特典",
      passportNumber: "パスポート番号",
      enterPassportNumber: "パスポート番号を入力してください",
      vehicleSwapRequest: "車両交換リクエスト",
      checkVehicleAvailability: "車両の空き状況を確認",
      pleaseSelectDateAndSearch:
        "日付を選択し、検索をクリックして車両の空き状況を確認してください",
      noVehicleFoundForSelectedDate: "選択した日に車両が見つかりません",
      notes: "メモ",
      writeYourNoteHere: "ここにメモを書いてください",
      updateRequest: "リクエストを更新",
      generateRequest: "リクエストを生成",
      cancelRequest: "リクエストをキャンセル",
      operator: "オペレーター",
      you: "あなた",
      maximum: "最大",
      imagesAreAllowed: "画像のアップロードが可能です。",
      dragAndDropFile: "ファイルをドラッグ＆ドロップまたはクリック",
      areAllowed: "が許可されています",
      cancelBooking: "予約をキャンセル",
      booked: "予約済み",
      organisation: "組織",
      vatNumber: "VAT番号",
      sort: "並び替え",
      DELETE_DRIVER_DESCRIPTION: "ドライバーを削除してもよろしいですか？",
      driverActions: {
        "Are you sure you want to delete the driver?":
          "ドライバーを削除してもよろしいですか？",
        "Delete Driver": "ドライバーを削除",
      },
      currentInvoiceStatus: {
        PAID: "支払い済み",
        UNPAID: "未払い",
        VOID: "無効",
        "PARTIALLY PAID": "一部支払い済み",
        DRAFT: "下書き",
      },
      currentBookingStatus: {
        CANCELLED: "キャンセル済み",
        COMPLETED: "完了",
        "CONFIRMATION IN PROCESS": "確認中",
        CONFIRMED: "確認済み",
        "IN PROGRESS": "進行中",
        QUOTE: "見積もり",
        DRAFT: "下書き",
        "REQUIRES APPROVAL": "承認が必要",
        DECLINED: "拒否済み",
      },
      minBookingDurationMessage:
        "最低予約時間は{{hours}}時間です。ピックアップまたは返却日時を調整してください。",
      maxBookingDurationMessage:
        "最大予約期間は{{days}}日です。ピックアップまたは返却日時を調整してください。",
      usevaletTypes: {
        Delivery: "配達",
        Collection: "集荷",
        "Delivery and Collection": "配達と集荷",
      },
      selectCollectionSlot: "集荷時間枠を選択",
      driverUnavailableNote:
        "注：ドライバーは利用できません。レンタル業者に連絡してください。",
      cancellationReasons: {
        "Requirement changed": "要件が変更された",
        Price: "価格",
        Other: "その他",
      },
      imagePreview: "画像プレビュー",
      markDamage: "損傷をマーク",
      vehicleDamageImages: "車両損傷の画像",
      incidentDate: "事故日",
      incidentTime: "事故時刻",
      clear: "クリア",
      bookingStatus: "予約ステータス",
      daysInBooking: "予約の日",
      accumulatedDays: "蓄積された日",
      endingThisMonth: "今月終了",
      creditUtilisation: "クレジット利用",
      creditLimit: "クレジット制限",
      utilized: "利用されています",
      totalDrivers: "総ドライバー",
      vehiclesAllocated: "割り当てられた車両",
      mileageOverview: "マイレージの概要",
      mileageLimitExited: "走行距離制限は終了しました",
      approachingMileageLimits: "マイレージ制限に近づく",
      motReminders: "MOTリマインダー",
      totalMotTests: "Total MOTテスト",
      healthCheckReminders: "健康診断のリマインダー",
      totalHealthCheckTests: "健康診断テストの合計",
      failed: "失敗した",
      serviceReminders: "サービスリマインダー",
      overdue: "期限切れ",
      totalServiceReminders: "総サービスリマインダー",
      createNewServiceRequest: "新しいサービスリクエストを作成",
      serviceDetails: "サービス詳細",
      selectedVehicle: "選択された車両",
      serviceRequestSelectVehicle: "車両を選択",
      loadingVehicles: "車両を読み込み中...",
      noActiveVehiclesFound: "アクティブな車両が見つかりません",
      addDetails: "詳細を追加",
      addItems: "項目を追加",
      issueType: "問題の種類",
      issueTypePlaceholder: "例：壊れた鍵",
      descriptionPlaceholder: "例：左前ドアのロック",
      uploaded: "アップロード済み",
      additionalComments: "追加コメント",
      additionalCommentsPlaceholder: "追加情報を入力してください...",
      submitting: "送信中...",
      submitRequest: "リクエストを送信",
      serviceRequestNote: "リクエストはサービスチームによって確認されます。承認されたとき、または追加情報が必要な場合に通知を受け取ります。",
      serviceRequestDetails: "サービスリクエストの詳細",
      createdDate: "作成日",
      estimatedCost: "推定費用",
      requestProgress: "リクエストの進捗",
      issuesReported: "報告された問題",
      issue: "問題",
      imageAlt: "画像",
      serviceProvider: "サービスプロバイダー",
      appointment: "予約",
      at: "時刻",
      estimatedCompletion: "完了予定",
      workToBeDone: "実施作業",
      cost: "費用",
      totalCost: "合計費用",
      requestDeclined: "リクエストが拒否されました",
      communication: "コミュニケーション",
      serviceTeam: "サービスチーム",
      noCommunicationYet: "まだコミュニケーションはありません",
      addMessage: "メッセージを追加",
      askQuestionPlaceholder: "質問をするか、追加情報を提供してください...",
      sending: "送信中...",
      sendMessage: "メッセージを送信",
      additionalInformationRequested: "追加情報が要求されました",
      provideFollowingInformation: "リクエストを処理するために、以下の情報を提供してください:",
      yourAnswer: "あなたの回答:",
      typeAnswerHere: "ここに回答を入力してください...",
      submitAnswers: "回答を送信",
      approved: "承認済み",
      serviceRequests: "サービスリクエスト",
      scheduledServicesTitle: "予定されているサービス",
      scheduledServicesBellAria: "予定されている車両サービスを表示",
      noScheduledServices: "予定されているサービスはありません",
      approveScheduledServiceSuccess: "サービスが正常に承認されました",
      requestChangesSuccess: "変更リクエストが承認のため送信されました",
      requestChanges: "変更をリクエスト",
      modifyServiceRequest: "サービスリクエストを変更",
      modifyDetails: "詳細を変更",
      vehicleAndCategory: "車両とカテゴリ",
      cannotModify: "変更できません",
      appointmentDetails: "予約の詳細",
      time: "時間",
      scheduledServiceReviewHint: "予定されているサービスをご確認ください。詳細が正しければ承認し、変更が必要な場合は変更をリクエストしてください。",
      approveService: "サービスを承認",
      jobSheet: "作業指示書",
      declined: "却下",
      lastUpdated: "最終更新",
      explainChangesPlaceholder: "これらの変更が必要な理由を説明してください...",
      submitChanges: "変更を送信",
      expenses: "経費",
      filters: "フィルター",
      applyFilters: "フィルターを適用",
      activeFilters: "アクティブなフィルター",
      newServiceRequest: "新しいサービスリクエスト",
      rowsPerPage: "ページあたりの行数:",
      of: "の",
      moreThan: "より多い",
      searchServiceRequestsPlaceholder: "参照番号、車両、またはステータスで検索...",
      selectOption: "オプションを選択",
      selectMultiple: "1つ以上のオプションを選択",
      uploadPhoto: "写真をアップロード",
      view: "表示",
      typeYourResponse: "回答を入力",
      pleaseSelectServiceType: "サービスタイプを選択してください",
      pleaseSelectServiceCategory: "サービスカテゴリを選択してください",
      selectServiceType: "サービスタイプを選択",
      serviceCategory: "サービスカテゴリ",
      selectServiceCategory: "サービスカテゴリを選択",
      unableToDetermineServiceBranch: "サービス支店を特定できませんでした。後でもう一度お試しください。",
      accidentDamageInformation: "事故 / 損傷情報",
      documentUploads: "ドキュメントアップロード",
      adHoc: "Ad-Hoc",
      emergency: "緊急",
      serviceQuestionnaire: "サービスアンケート",
      serviceQuestionnaireDescription: "サービスチームが事前にすべてを準備できるよう、いくつかの追加の詳細を提供してください。",
      selectServiceCategoryPrompt: "このサービスの必須質問を表示するには、サービスカテゴリを選択してください。",
      noServiceQuestionsForType: "このサービスタイプに追加の質問はありません。リクエストを続行できます。",
      fileUploadGuidance: "ファイルあたり最大5MBのJPEG/PNG。",
      optionalServiceQuestion: "オプションの質問 — チームに役立つ場合は回答してください。",
      requestCreated: "リクエスト作成済み",
      underReview: "審査中",
      inProgress: "進行中",
      photo: "写真",
      hiThere: "こんにちは、",
      serviceRequestDeclinedMessage: "サービスリクエストを確認しましたが、現時点では承認できませんでした。",
      whatWeNeed: "必要なもの：",
      declineReasonGeneric: "これは、詳細の不足、サービスの適格性、またはその他の承認条件が原因である可能性があります。",
      declineInstruction: "情報を確認し、これらの更新が完了したら新しいリクエストを送信してください。",
      answered: "回答済み",
      pendingAnswer: "回答待ち",
      requiredField: "この回答は必須です",
      questionsAnswered: "質問に回答済み",
      readyToSubmitChanges: "更新を送信する準備ができました",
      questionsUpToDate: "すべての回答が最新です",
      updateAnyAnswerToResubmit: "新しい情報を送信する必要がある場合は、上記の回答を更新してください。",
      answerTypeText: "テキスト",
      answerTypeYesNo: "はい / いいえ",
      answerTypeDropdown: "ドロップダウン",
      answerTypeMultiSelect: "複数選択",
      answerTypeFileUpload: "写真アップロード",
      pendingApproval: "承認待ち",
      awaitingMoreInformation: "追加情報待ち",
      closed: "閉鎖",
      noServiceRequestsFound: "サービスリクエストが見つかりませんでした",
      fleetAllocation: "フリート割り当て",
      fleetAllocations: "フリート割り当て一覧",
      userAgreement: "ユーザー契約",
      organisationCode: "組織コード",
      serviceReference: "サービス参照",
      completionDate: "完了日",
      addTask: "タスクを追加",
      noTaskFound: "タスクが見つかりません。手動でタスクを追加できます。",
      taskName: "タスク名",
      features: "機能",
      interiorFeatures: "インテリア機能",
      exteriorFeatures: "エクステリア機能",
      safetyAndTechnicalFeatures: "安全・技術機能",
      otherFeatures: "その他の機能",
      privateHiresNo: "民間採用番号",
      pcoPrivateHiresHireDLNo: "PCO/プライベートレンタルdl no",
      gender: "性別",
      secondaryEmailAddress: "セカンダリメールアドレス",
      secondaryPhoneNumber: "セカンダリ電話番号",
      driverAge: "ドライバーの年齢",
      licenceDuration: "ライセンス期間",
      penaltyPoints: "ペナルティポイント",
      insuranceClaimsHistory: "保険金請求履歴",
      pcoExpiryDate: "PCO有効期限",
      state: "状態",
      selectBookingType: "予約タイプを選択",
      selectBookingTypeDialog: "予約を続行するには、以下の予約タイプのいずれかを選択してください",
      regularBooking: "通常予約",
      contactlessBooking: "非接触予約",
      reviewBookingDetails: "予約の詳細を確認",
    },
    misc: {
      edit: "編集",
      logOut: "ログアウト",
      licence: "ライセンス",
      cancel: "キャンセル",
      save: "保存",
      status: {
        PENDING: "保留中",
        APPROVED: "承認済み",
        DECLINED: "却下",
        IN_REVIEW: "審査中",
      },
      delete: "削除",
      create: "作成",
      signIn: "サインイン",
      select: "選択",
      back: "戻る",
      error: "エラー",
      yes: "はい",
      no: "いいえ",
      payConfirm: "支払いと確認",
      clickToAdd: "クリックして追加",
      close: "閉じる",
      download: "ダウンロード",
      selectCaps: "選択",
      forgotPassword: "パスワードをお忘れですか",
      pleaseNote: "ご注意ください",
      front: "表面",
      columnKey: {
        "#": "#",
        Particulars: "詳細",
        Quantity: "数量",
        "Unit Price": "単価",
        Duration: "期間",
        "Discounted Price": "割引価格",
        "VAT/TAX": "消費税/税金",
        Amount: "金額",
      },
      columnLabelToKeyMap: {
        ITEM: "項目",
        DESCRIPTION: "説明",
        QUANTITY: "数量",
        "UNIT PRICE": "単価",
        DURATION: "期間",
        "DISCOUNTED PRICE": "割引価格",
        "VAT/TAX": "税",
        PRICE: "価格",
      },
      paymentColumnsKey: {
        Date: "日付",
        Amount: "金額",
        "Mode Of Payments": "支払方法",
        Status: "ステータス",
      },
      consolidatedInvoicesColumnsKey: {
        "#": "#",
        "Invoice Reference Number": "請求書番号",
        "Vehicle Registration Numbers": "車両登録番号"
      },
      buttonKey: {
        Rentals: "レンタル",
        Subscriptions: "サブスクリプション",
        "Test Drive": "試乗",
        "Contract Hire": "契約リース",
      },
      subLabelKey: {
        "Book vehicle for hours and days": "車両を時間単位・日単位で予約",
        "Subscribe vehicle for weekly/monthly":
          "週単位・月単位で車両をサブスクライブ",
        "Test Drive our Premium Vehicles": "プレミアム車両を試乗",
        "Contract Hire vehicle for weekly/monthly": "週・月単位の契約リース",
      },
      buttonTextKey: {
        "Subscribe Now": "今すぐサブスクライブ",
        "Book Now": "今すぐ予約",
        "Contract Now": "今すぐ契約",
      },
      featuresKey: {
        "Flexible Leasing Options": "柔軟なリースオプション",
        "Choose the duration of your subscription as you go":
          "サブスクリプション期間を自由に選択",
        "Change car anytime*": "いつでも車を変更*",
        "Home delivery option": "自宅配送オプション",
        "100% digital": "完全デジタル",
        "MOT and taxes": "車検と税金",
        "Without down payment": "頭金なし",
        "Vehicle Servicing": "車両整備",
      },
      adjustmentColumnKey: {
        "#": "#",
        Amount: "金額",
        "Adjusted To Invoice": "請求書に調整",
        "Adjusted At": "調整日時",
      },
      categoriesKey: {
        Knowledge: "知識",
        Behavior: "行動",
        Punctuality: "時間厳守",
      },
    },

    snackBar: {
      customerInfoSaved: "顧客情報が節約されました",
      documentDeleted: "ドキュメントは正常に削除されました",
      documentDeleteFailed: "ドキュメントの削除に失敗しました",
      documentDeleteError: "ドキュメントを削除するエラー",
      documentMarkedForDeletion:
        "ドキュメントは削除対象としてマークされています。変更は保存時に適用されます。",
      profileImageUploaded: "プロファイル画像が正常にアップロードされました",
      uploadImageFormatError:
        ".jpeg/.jpg/.png画像形式のみをアップロードしてください！",
      selectDocumentType: "ドキュメントタイプを選択してください",
      selectExpiryDate: "ドキュメントの有効期限を選択してください",
      fileSizeExceeded50mb: "ファイルサイズは50MBの制限を超えました",
      fileSizeExceeded5mb: "ファイルサイズは5MBの制限を超えました",
      uploadSuccess: "ドキュメントは正常にアップロードされました",
      invalidUploadFormat:
        "PDF、PNG、JPG、またはJPEGファイルのみをアップロードしてください",
      selectExpiryDateUpload: "アップロードする前に有効期限を選択してください",
      ImageUploaded: "画像が正常にアップロードされました",
      invalidFileType:
        "無効なファイルタイプです。許可されているタイプ: jpeg または png",
      costCenterInfoMissing: "コストセンターの情報がありません！",
      selectedDriverAlreadyAdded: "選択したドライバーは既に追加されています。",
      driverSavedSuccessfully: "ドライバーが正常に保存されました。",
      additionalDriverCannotBeMore:
        "追加ドライバーはアドオンの数量を超えることはできません",
      verificationStatusInReview: "検証状況は審査中です",
      verificationStatusPending: "検証状況は保留中です",
      quoteCreated: "見積もりが作成されました",
      bookingCreated: "予約が作成されました",
      pickUpLocationEmpty: "ピックアップ場所が空です",
      slotSelectionRequiredForNonNegotiable: "スロットの選択が必要です。",
      protectionPlanMandatoryForPCOBooking: "この予約には保護プランが必須です",
      paymentAlreadyDone: "支払いはすでに完了しています",
      fileBeingGenerated:
        "ファイルを生成中です。しばらくしてから再試行してください",
      provideDeliveryAddress: "配達先住所を入力してください！",
      noValidCreditReadingFound:
        "この会社の有効な信用情報が見つかりませんでした。",
      noValidCreditScoreFound:
        "有効なクレジットスコアが見つかりません。信用調査回数の上限を超えた可能性があります。",
      atleastOneLicenceImage:
        "少なくとも1枚の免許証画像をアップロードしてください",
      licenceImageUploaded: "免許証画像が正常にアップロードされました",
      maximumTwoImageLicence:
        "免許証には最大2枚の画像のみアップロードできます！",
      imageUploadInProgress:
        "画像のアップロード中です。しばらくお待ちください！",
      errorFetchingSignedUrl: "署名付きURLの取得エラー",
      paymentFailed: "支払いに失敗しました。再試行してください",
      paymentFailedReasonCardDetails:
        "支払いに失敗しました！カード情報を確認するか、後でもう一度お試しください。",
      maximumTwoImage: "最大2枚の画像をアップロードできます：",

      cancelledSuccessfully: "正常にキャンセルされました",
      selectReasonForCancel: "キャンセルの理由を入力してください",
      streetZipcodeRequired: "通り / 郵便番号は必須です",
      feedbackSaved: "ありがとうございます！フィードバックが保存されました",
      driverAlreadyAdded: "ドライバーはすでに追加されています！",
      driverRemoved: "ドライバーが正常に削除されました",
      businessCustomerDriverDeleted: "法人顧客のドライバーが削除されました。",
      errorInSavingData: "データの保存中にエラーが発生しました",
      damageInformationSaved: "損傷情報が正常に保存されました。",
      errorSavingData: "データ保存時にエラーが発生しました",
      problemTelematicsData: "テレマティクスデータの読み込みエラー",
      verificationRequestSent: "確認リクエストが正常に送信されました。",
      vehicleStateUpdated: "車両の状態が更新されました",
      driverAdded: "ドライバーが追加されました。",
      businessCustomerCreated: "法人顧客が作成されました。",
      uploadOnlyImageFiles: "画像ファイル（PNG、JPEG、JPG）のみをアップロードしてください",
      imageSizeExceed5MB: "画像サイズは5MBを超えないでください",
      uploadFailed: "アップロードに失敗しました",
      imagesUploadedSuccessfully: "画像が正常にアップロードされました！",
      failedToUploadImages: "画像のアップロードに失敗しました。もう一度お試しください。",
      pleaseSelectVehicle: "車両を選択してください",
      pleaseFillInAllIssueDetails: "すべての問題の詳細を入力してください",
      serviceRequestCreatedSuccessfully: "サービスリクエストが正常に作成されました！参照番号：",
      errorCreatingServiceRequest: "サービスリクエストの作成中にエラーが発生しました",
      pleaseEnterNote: "メモを入力してください",
      noteAddedSuccessfully: "メモが正常に追加されました",
      errorAddingNote: "メモの追加中にエラーが発生しました",
      pleaseAnswerAllRemainingQuestions: "残りの{{count}}つの質問{{plural}}にすべて回答してください",
      answersSubmittedSuccessfully: "回答が正常に送信されました！リクエストは現在確認中です。",
      errorSubmittingAnswers: "回答の送信中にエラーが発生しました",
      serviceRequestNotFound: "サービスリクエストが見つかりません",
      errorLoadingServiceRequests: "サービスリクエストの読み込みエラー",
      oneVehicleForContactless: "非接触予約では1台の車両のみ選択できます",
      oneVehicleForNonContactless: "非接触予約では、非接触車両またはSmartcar車両のみ選択できます",
      contactlessVehicleCannotBeSelected: "通常予約では非接触車両を選択できません",
      bookingDetailsCreated: "予約の詳細が作成されました"
    },
    validation: {
      otpLengthMismatch: "OTPの長さは6文字である必要があります",
      invalidOtp: "無効な OTP",
      required: "{{field}} が必要です",
      billingEmailInvalid: "有効な請求メールを入力してください。",
      billingEmailRequired: "請求メールが必要です。",
      addressRequired: "アドレスが必要です",
      phoneNumberRequired: "電話番号が必要です。",
      businessNameRequired: "ビジネス名が必要です。",
      registrationNumberRequired: "登録番号が必要です",
      vatRequired: "VAT/税登録番号が必要です",
      accountNumberRequired: "口座番号が必要です",
      registeredAddressRequired: "登録アドレスが必要です",
      registeredAddressCountryRequired: "国が必要です",
      registeredAddressStateRequired: "状態が必要です",
      registeredAddressCityRequired: "都市が必要です",
      registeredAddressStreetRequired: "通りが必要です",
      tradingAddressRequired: "取引住所が必要です",
      tradingAddressCountryRequired: "国が必要です",
      tradingAddressStateRequired: "状態が必要です",
      tradingAddressCityRequired: "都市が必要です",
      tradingAddressStreetRequired: "通りが必要です",
      contactEmailRequired: "お問い合わせメールが必要です。",
      firstNameRequired: "名が必要です。",
      middleNameRequired: "ミドルネームは必須です。",
      lastNameRequired: "姓が必要です。",
      locationRequired: "場所が必要です",
      streetZipcodeRequired: "通り/zipcodeが必要です",
      emailIsRequired: "メールは必須です",
      termsConditionsAccepted: "利用規約に同意する必要があります",
      drivingLicenceNumberRequired: "運転免許証番号は必須です",
      nationalInsuranceNumberRequired: "国民保険番号は必須です",
      enterValidPhoneNumber: "有効な電話番号を入力してください。",
      enterValidEmailAddress: "有効なメールアドレスを入力してください",
      authorityRequired: "発行機関は必須です",
      licenceNumberRequired: "免許証番号は必須です",
      licenceExpiryDateRequired: "免許証の有効期限は必須です",
      expiryDateRequired: "有効期限が必要です",
      numberIsRequired: "番号が必要です",

      passwordLengthValidaion: "パスワードは8文字以上でなければなりません",
      passwordContainUppercase: "パスワードには少なくとも1つの大文字が必要です",
      passwordContainLowercase: "パスワードには少なくとも1つの小文字が必要です",
      passwordContainOneNumber: "パスワードには少なくとも1つの数字が必要です",
      passwordContainSpecialCharacter:
        "パスワードには少なくとも1つの特殊文字が必要です",
      passwordMustMatch: "パスワードが一致していません",
      atleastOneUppercase: "大文字を1文字以上含む",
      atleastOneLowercase: "小文字を1文字以上含む",
      atleastOneNumericalChar: "数字を1文字以上含む",
      atleastOneSpecialChar: "特殊文字を1文字以上含む",
      pleaseEnterAValidEmail: "有効なメールアドレスを入力してください",
      driverNotFound: "ドライバーが見つかりません",
      batteryStatusNumber: "バッテリーステータスは数値でなければなりません",
      batteryStatusCantNegative: "バッテリーステータスは負の値にできません",
      batteryStatusCantMoreHundred:
        "バッテリーステータスは100%を超えることはできません",
      batteryStatusRequired: "バッテリーステータスは必須です",
      odometerReadingMustNumber: "走行距離は数値でなければなりません",
      odometerReadingRequired: "走行距離は必須です",
      odometerMustEqualOrHigherLast:
        "走行距離は前回の値以上である必要があります",
      titleIsRequired: "タイトルは必須です。",
      damageKindIsRequired: "損傷の種類は必須です。",
      descriptionIsRequired: "説明は必須です。",
      damageImageIsRequired: "損傷画像は必須です。",
      professionIsRequired: "職業が必要です",
      passportNineCharacters: "パスポート番号は9文字でなければなりません",
      passportIsRequired: "パスポートが必要です",
      organisationCodeRequired: "組織コードが必要です",
      userNotFound: "ユーザーが見つかりません",
      invalidPassword: "無効なパスワード",
      passwordLengthError: "パスワードは8文字以上である必要があります",
      customerPCONumberRequired: "PCO／プライベートハイヤー免許番号は必須です",
      genderRequired: "性別は必須です",
      nationalityRequired: "国籍は必須です",
    },
  },
};